import { Injectable, inject } from '@angular/core';
import { AbilityService } from 'ability';
import { AgentOptionsFacade } from 'mbs-ui-shared@facades/agent-options.facade';
import { ComputerBackupFacade } from 'mbs-ui-shared@facades/computer.backup.facade';
import { RemoteDeployDataFacade } from 'mbs-ui-shared@facades/remote-deploy-data.facade';
import { RemoteManagementWizardsService } from 'wizards/services/remote-management-wizards.service';

@Injectable({
  providedIn: 'root'
})
export class WizardsServicesHubService {
  ability = inject(AbilityService);
  mainService = inject(RemoteManagementWizardsService);
  rdService = inject(RemoteDeployDataFacade);
  agentOptionsService = inject(AgentOptionsFacade);
  backupFacade = inject(ComputerBackupFacade);
}
